<!--
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2024-01-02 10:01:39
 * @FilePath: /smartEarthDemo/src/demo/scene/rPark.vue
 * @Description: 
-->
<template>
<div style="height:100%">
    <div id="csContainer">
    </div>
    <div id="loadingOverlay"><h1>Loading........</h1></div>
</div>
</template>

<script>
/* eslint-disable */
import * as Cesium from "cesium/Cesium";
import widgets from "cesium/Widgets/widgets.css";
import util from "../../components/util"

export default {
    name: "ruanjianyuanModel",

    data () {
        return {
            viewer: null
        }
    },

    mounted() {
        var loa=document.getElementById('loadingOverlay');
       setTimeout(()=>{
           loa.style.display="none";
       },4000);
        this.init();
    },
    methods: {
        init() {
            this.viewer = util.getViewer("csContainer",{
                // imageryProvider : new Cesium.UrlTemplateImageryProvider({
                //     // url: "http://webrd02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}",
                //     url: "http://172.17.13.60:8820/{z}/{x}/{y}.png",
                //     layers: 'earth'
                // }),
                    baseLayerPicker: false
            })
            let viewer = this.viewer;
            let tileset = new Cesium.Cesium3DTileset({
                url:  "/demo/static/data/models/sketchup/tileset.json",
                maximumScreenSpaceError: 0.1,
                maximumMemoryUsage: 2048
            });
            let longitude = 116.298782
            let latitude = 40.047981
            let height = 0
            let scale = Cesium.Matrix4.fromUniformScale(0.25);

            // let m = Cesium.Matrix4.fromArray([
            //     1, 0.0, 0.0, 0.0,
            //     0.0, 1, 0.0, 0.0,
            //     0.0, 0.0, 1, 0.0,
            //     0, 0, 1000, 1.0
            // ]);

            tileset.readyPromise.then(function(tileset) {

                let hpr = new Cesium.Matrix3();

                var heading=Cesium.Math.toRadians(-22);

                // heading围绕负z轴的旋转。pitch是围绕负y轴的旋转。Roll是围绕正x轴的旋转
                let hprObj = new Cesium.HeadingPitchRoll(heading, Math.PI, Math.PI)
                hpr = Cesium.Matrix3.fromHeadingPitchRoll(hprObj, hpr)


                let modelMatrix = Cesium.Matrix4.multiplyByTranslation(
                    Cesium.Transforms.eastNorthUpToFixedFrame(Cesium.Cartesian3.fromDegrees(longitude, latitude, height)),
                    new Cesium.Cartesian3(), new Cesium.Matrix4()
                );
                modelMatrix = Cesium.Matrix4.multiplyByMatrix3(modelMatrix, hpr, modelMatrix);

                tileset._root.transform = Cesium.Matrix4.multiply(modelMatrix, scale, modelMatrix)
                viewer.scene.primitives.add(tileset);
                viewer.zoomTo(tileset);
            }).otherwise(function(error) {
                console.log(error);
            });

        },

    },
  }
</script>

<style scoped>

  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
